// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__i8SpC","colBig":"styles_colBig__AE73I","colSmall":"styles_colSmall__r3q55"};